import { useFormikContext } from 'formik';
import { useEffect } from 'react';

export default function SetFieldText({ field, text }: { field?: string; text: string }) {
    const { values, setFieldValue } = useFormikContext();

    useEffect(() => {
        if (!field) {
            return;
        }

        if ((values as any)[field] !== text) {
            setFieldValue(field, text);
        }
    }, [field, text, setFieldValue]);

    return null;
}
